import { Component, OnInit, EventEmitter } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';
import { UserQuestionsService } from '../../../_services/user-questions.service';

export interface QuestionAnswerModel {
    id: number,
    question: string,
    answer: string,
    uid: string,
    lineBotId: number
}

@Component({
    selector: 'app-reply-question',
    templateUrl: './reply-question.component.html',
    styleUrls: ['./reply-question.component.css']
})

export class ReplyQuestionComponent extends DialogComponent<QuestionAnswerModel, boolean> implements OnInit {
    model: any = {};
    loading: boolean;
    id: string;
    question: string;
    answer: string;
    uid: string;
    lineBotId: string;
    message: string;
    focusEventEmitter = new EventEmitter<boolean>();
    
    constructor(dialogService: DialogService, private userQuestionsService: UserQuestionsService) {
        super(dialogService);
    }

    ngOnInit() {
        this.model.id = this.id;
        this.model.uid = this.uid;
        this.model.lineBotId = this.lineBotId;
        this.model.question = this.question;
        this.model.answer = this.answer;
    }

    ngAfterViewInit() {
        this.focusEventEmitter.emit(true);
    }
    
    reset() {
        this.message = '';
        this.userQuestionsService.reply(this.model).subscribe(data => {
            if (data.error == false) {
                this.close();
                this.result = true;
            } else {
                this.message = data.message;
                $('#answer').select();
            }
        });
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user-questions/reply-question/reply-question.component.ts